import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statStockChartLocaleModule: LocaleModule = {
  name: "statStockChart",
  messages: { en: en, it: it },
};
